import { FilterConfig } from '@sm-dashboard/types';

/** Free-text search box (חיפוש) — default field chrome, not plain. */
export const isSearchFilter = (filter: Pick<FilterConfig, 'type' | 'field' | 'label'>): boolean => {
  if (filter.type !== 'text' && filter.type !== undefined) return false;

  const field = String(filter.field);
  if (field === 'searchTerm' || /search/i.test(field)) return true;

  return filter.label === 'חיפוש' || filter.label === 'חיפוש חופשי' || filter.label.startsWith('חיפוש');
};
